import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Endpoints } from '../../../api/Constants';
import utils from '../../../utils';
export var postForgotPasswordMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.FORGOT_PASSWORD),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          subplatform: utils.getSubPlatform(),
          launch_type: utils.getSource()
        })
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  }
};